import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthenticationService} from '../../../services/apiServices/security/authentication.service';
import {TranslateService} from '@ngx-translate/core';
import {BROWSERS, DeviceDetectorService, DeviceInfo} from 'ngx-device-detector';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {instances} from '../../../properties';
import {CommonService} from '../../../services/apiServices/business/common.service';
import {ModService} from '../../../services/apiServices/business/mod.service';


/**
 * top navigation bar
 */
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NavbarComponent implements OnInit {
  /**
   * the emiter that handleChangeOfSelectFold propagation when the user wants to change the Password
   */
  @Output()
  public paramDialog: EventEmitter<boolean>;
  @Output()
  public downloadVirtualPrinter: EventEmitter<boolean>;
  @Output()
  public actionLogging: EventEmitter<boolean>;
  mopAvailable: boolean;
  openHelp: boolean;
  msBrowsers: boolean;
  private deviceInfo: DeviceInfo;
  mopFile: any;
  public navBarClass: string;
  public navBarlogo: string;
  public logoClass: string;
  public motdClass: string;
  isAdminLog = false;
  isAdminNumen = false;
  /**
   * Toaster title content on success login
   */
  private succesLogoutTitle: string;

  /**
   * Toaster Message content on success logout
   */
  private succesLogoutMessage: string;


  constructor( private authenticationService: AuthenticationService, private translateService: TranslateService,
              private httpClient: HttpClient, private commonService: CommonService, private modService: ModService,
               private deviceService: DeviceDetectorService) {
    this.paramDialog = new EventEmitter();
    this.downloadVirtualPrinter = new EventEmitter();
    this.actionLogging = new EventEmitter();
    this.isAdminLog = this.authenticationService.isAdminLog();
    this.isAdminNumen = this.authenticationService.isAdminNumen();
  }

  /**
   * Retrieve message of the day
   */
  public ngOnInit(): void {
    this.navBarClass = environment.instance + '-app-nav-bar';

    this.logoClass = 'col-2';
    this.motdClass = 'col-8';
    if (instances[environment.instance] && instances[environment.instance].navBar && instances[environment.instance].navBar.logoClass) {
      this.logoClass = instances[environment.instance].navBar.logoClass;
    }
    if (instances[environment.instance] && instances[environment.instance].navBar && instances[environment.instance].navBar.motdClass) {
      this.motdClass = instances[environment.instance].navBar.motdClass;
    }
    this.navBarlogo = instances.numen.login.logo;
    if (instances[environment.instance] && instances[environment.instance].login && instances[environment.instance].login.logo) {
      this.navBarlogo = instances[environment.instance].login.logo;
    }
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.msBrowsers = (BROWSERS.IE === this.deviceInfo.browser || BROWSERS.MS_EDGE === this.deviceInfo.browser);
    this.mopAvailable = false;
    this.openHelp = false;
    this.getTradForComponent();
    if (instances[environment.instance] && instances[environment.instance].showMOP) {
      this.getMopFile().subscribe(( response: any ) => {
        if (response && response.status === 200) {
          this.mopAvailable = true;
        }
      });
    }
  }
  /**
   * ask to the authenticationService to log-out the current user
   */
  public logout(): void {
    this.commonService.addToast({life: 3000, severity: 'info', summary: this.succesLogoutTitle, detail: this.succesLogoutMessage});
    this.authenticationService.logout();
  }

  /**
   * open the PasswordChange component
   */
  public openParamDialog(): void {
    this.paramDialog.emit(true);
  }

  /** open the chooseVirtualPrinter to download component
   *
   *    */
  public openDownloadVirtualPrinter(): void {
    this.downloadVirtualPrinter.emit( true );
  }
  /** open the action logging to download component
   *
   *    */
  public openActionLogging(): void {
    this.actionLogging.emit( true );
  }
  /**
   * get MOTD from json file, determine the proper language to display
   */
  private getTradForComponent(): void {
    this.translateService.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe((translation: string) => {
      this.succesLogoutTitle = translation;
    });
    this.translateService.get('TOASTER.LOGOUT_SUCCES_MESSAGE').subscribe((translation: string) => {
      this.succesLogoutMessage = translation;
    });
  }

  public freeDocMemory(documentToFree): void {
    window.URL.revokeObjectURL(documentToFree);
  }
  getMopFile(): Observable<Object> {
      return this.httpClient.get('../assets/mop.pdf', {
      headers: new HttpHeaders({ 'Content-Type': 'application/pdf' } ),
      responseType: 'blob',
      observe: 'response'
    } );
  }
  public showMop(): void {
    if (this.msBrowsers) {
      window.open('../assets/mop.pdf', '_blank');
    } else {
      this.getMopFile().subscribe(( response: any ) => {
        const typeOfReponse = response.headers.get('content-type');
        if (typeOfReponse && typeOfReponse.includes('pdf')) {
          const blob = new Blob([ response.body ], {type: 'application/pdf'});
          this.mopFile = window.URL.createObjectURL(blob);
          this.openHelp = true;
        }
      });
    }
  }
  public getUserMessageOfTheDay(): string {
    return this.modService.getUserMessageOfTheDay();
  }
}
